module.exports = __webpack_public_path__ + "img/man.a6d3fcd9.svg";